const filtersLabels: Record<string, string> = {
  "filters-locationType": "Location type",
  "filters-networkStatus": "Network status",
  "filters-status": "Status",
  "filters-accountType": "Account Type",
  "filters-performanceRating": "Performance Rating",
  "filters-role": "Role",
  "filters-integrationStatus": "Integrations Status",
  "filters-AccessTechnology": "Access Technology",
  "filters-interface": "Interface/Handoff Type",
  "filters-IP": "IP",
  "filters-DcServiceType": "Type",
  "filters-currency": "Currency",
  "filters-rackSize": "Rack Size",
  "filters-hoursType": "Hours Type",
  "filters-purchaseType": "Purchase Type",
  "filters-maintenanceType": "Maintenance Type",
  "filters-maintenanceSla": "Maintenance SLA",
  "filters-maintenanceStatus": "Maintenance Status",
  "filters-licenseStatus": "License Status",
  "filters-onSiteDeliveryIncluded": "On-site Delivery Included",
  "filters-dutiesIncluded": "Custom/Duties Included",
  "filters-onSiteInstallationIncluded": "On-site Installation Included",
  "filters-dataLimitType": "Data Limit Type",
  "filters-isLocalTax": "Local Tax/VAT*",
  "filters-priceCode": "Price code",
  "filters-fieldServiceType": "Field service type",
  "filters-qinqSupported": "QinQ Supported",
  "filters-type": "Product Type",
  "filters-contractTerms": "Contract Terms",
  "filters-quoteLineType": "Quote Type",
  "filters-CPE": "CPE",
  "filters-userType": "User Type",
  "filters-subType": "Type",
  "filters-airxProductType": "AIRX Product Name",
  "filters-contractTerm": "Contract Terms",
  "filters-notificationType": "Type",
  "filters-targetCurrency": "Target Currency",
};

export default filtersLabels;
